module.exports = __webpack_public_path__ + "img/watermark.b34e79a7.svg";